/* ============
 * Mutations for the delegate module
 * ============
 *
 * The mutations that are available on the
 * delegate module.
 */
import array from '@/utils/array';
import types from './mutation-types';

export default {
  [types.FETCH_DELEGATE_LIST](state) {
    state.isDelegatesLoading = true;
  },
  [types.FETCH_DELEGATE_LIST_SUCCESS](state, response) {
    state.isDelegatesLoading = false;
    state.totalCount = response.totalCount;
    state.delegates = response.patientDelegate;
  },
  [types.FETCH_DELEGATE_LIST_FAIL](state, error) {
    state.isDelegatesLoading = false;
    state.error = error;
  },
  [types.UPDATE_DELEGATE](state) {
    state.isDelegatesUpdating = true;
  },
  [types.UPDATE_DELEGATE_SUCCESS](state, { response, patient }) {
    const patientIndex = array.findIndexOfObject(state.delegates, 'mr_id', patient.mr_id);
    const delegateIndex = array.findIndexOfObject(
      state.delegates[patientIndex].delegate,
      'delegate_id',
      response.delegate_id
    );
    const updatedDelegates = state.delegates;
    updatedDelegates[patientIndex].delegate[delegateIndex] = {
      ...updatedDelegates[patientIndex].delegate[delegateIndex],
      ...response
    };
    state.delegates = [...updatedDelegates];
    state.isDelegatesUpdating = false;
  },
  [types.UPDATE_DELEGATE_FAIL](state, error) {
    state.isDelegatesUpdating = false;
    state.error = error;
  }
};
